module.exports = __webpack_public_path__ + "static/simple-model-112606a10d9be89ab56aa18ef510ac30.gif";